var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66662 1.33331L2.72892 8.45855C2.49638 8.7376 2.38011 8.87712 2.37833 8.99495C2.37679 9.09739 2.42244 9.19485 2.50212 9.25924C2.59378 9.33331 2.7754 9.33331 3.13864 9.33331H7.99995L7.33328 14.6666L13.271 7.54141C13.5035 7.26236 13.6198 7.12284 13.6216 7.00501C13.6231 6.90257 13.5775 6.80511 13.4978 6.74072C13.4061 6.66665 13.2245 6.66665 12.8613 6.66665H7.99995L8.66662 1.33331Z",
    stroke: "url(#paint0_linear_1083_33880)",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1083_33880",
    x1: 2.3783,
    y1: 14.6666,
    x2: 15.5202,
    y2: 3.5848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE46BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightning);
export default __webpack_public_path__ + "static/media/icon-lightning.b664b1c4373424b3bc661ef8888108c9.svg";
export { ForwardRef as ReactComponent };